/**
 * p80: hidden carousel slides leave the tab order.
 *
 * Horizon's slideshow marks off-screen slides `aria-hidden="true"` but leaves their links
 * focusable (axe `aria-hidden-focus`, serious; handoff audit 2026-10-19). This mirrors the
 * attribute to `inert` on every `slideshow-slide`, including slides added later, so a
 * hidden slide is hidden for keyboard users too. Slides become reachable again as soon as
 * Horizon reveals them (scroll, arrows, dots set `aria-hidden="false"`).
 */
const SLIDE = 'slideshow-slide';

/** @param {Element} slide */
function sync(slide) {
    const hidden = slide.getAttribute('aria-hidden') === 'true';
    if (hidden !== slide.hasAttribute('inert')) slide.toggleAttribute('inert', hidden);
}

function syncAll(root = document) {
    root.querySelectorAll(SLIDE).forEach(sync);
}

const observer = new MutationObserver((records) => {
    for (const record of records) {
        if (record.type === 'attributes') {
            if (record.target instanceof Element && record.target.localName === SLIDE)
                sync(record.target);
        } else {
            record.addedNodes.forEach((node) => {
                if (!(node instanceof Element)) return;
                if (node.localName === SLIDE) sync(node);
                syncAll(node);
            });
        }
    }
});

observer.observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['aria-hidden']
});
syncAll();
